import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

export const useCheckStatus = () =>
  useQuery({
    queryKey: ['auto-test-status'],
    queryFn: async () => {
      const { data } = await $apiV2.get(`/auto-test/check-status`);

      return data;
    },
    refetchOnMount: true
  });
